import React, {useState} from 'react';
import {createUserWithEmailAndPassword, sendEmailVerification} from "firebase/auth";
import {auth} from '../../firebase';
import './Login.css';
import {useNavigate} from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

const Register = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const [error, setError] = useState('');
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            setError('Οι κωδικοί δεν ταιριάζουν');
            return;
        }
        if (!captchaVerified) {
            setError('Παρακαλώ ολοκληρώστε το Captcha');
            return;
        }

        // Check if user agreed to terms
        if (!agreeToTerms) {
            setError('Πρέπει να συμφωνήσετε με τους όρους & προϋποθέσεις');
            return;
        }

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            await sendEmailVerification(userCredential.user);
            navigate('/map');
        } catch (error) {
            setError(error.message);
        }
    };

    const handleCaptchaChange = (value) => {
        setCaptchaVerified(!!value);
    };

    return (<div className="login-container">
        <form className="login-form" onSubmit={handleRegister}>
            <h2>Εγγραφή</h2>
            <div>
                <label>Ηλεκτρονικό ταχυδρομείο:</label>
                <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
            </div>
            <div>
                <label>Κωδικός πρόσβασης:</label>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
            </div>
            <div>
                <label>Επιβεβαίωση κωδικού πρόσβασης:</label>
                <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                />
            </div>

            {/* Terms & Conditions Checkbox */}
            <div className="terms-container">
                <input
                    type="checkbox"
                    id="agreeToTerms"
                    checked={agreeToTerms}
                    onChange={(e) => setAgreeToTerms(e.target.checked)}
                />
                <label htmlFor="agreeToTerms">
                    Συμφωνώ με τους{' '}
                    <a
                        href="/documents/RGD%20Map-%20Terms%20of%20conditions.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        όρους & προϋποθέσεις
                    </a>
                </label>
            </div>

            <div className="captcha-container">
                <ReCAPTCHA
                    sitekey="6Ld4Uu8qAAAAAHKOA6DxUthUle7bggoRZDE9p3rW"
                    onChange={handleCaptchaChange}
                />
            </div>
            {error && <p>{error}</p>}
            <button type="submit">Εγγραφή</button>
        </form>
    </div>);
};

export default Register;